import React from "react";
import { formatCurrency } from "@platform-static/string-utils";
import { TableCell, TableRow } from "../../platform-style";
import { formatPercentage } from "../../utils/NumberUtils";

export interface TableRowsFromObjectProps<T> {
  data: T;
  labels: FieldsWithLabels[];
  showEmpty?: boolean;
}

export interface FieldsWithLabels {
  name: string;
  label: string;
}

export const TableRowsFromObject = <T extends object>(props: TableRowsFromObjectProps<T>) => {
  let content: React.JSX.Element[] = [];
  Object.entries(props.data).map(([key, value]) => {
    if (props.showEmpty || value) {
      let fieldDef = props.labels.find((i) => i.name.toLowerCase() === key.toLowerCase());
      let formattedValue: string | null = "";
      if (fieldDef?.name.includes("Amount")) {
        formattedValue = formatCurrency(Number(value));
      } else if (fieldDef?.name.includes("Date")) {
        if (value.length === 7) {
          formattedValue = value.slice(5, 7) + "/" + value.slice(0, 4);
        } else {
          formattedValue = new Date(value + "T00:00:00").toLocaleDateString();
        }
      } else if (
        fieldDef?.name.includes("Rate") ||
        fieldDef?.name.includes("Percentage") ||
        fieldDef?.name.includes("Ratio")
      ) {
        formattedValue = formatPercentage(Number(value));
      } else {
        formattedValue = value;
      }
      if (fieldDef) {
        content.push(
          <TableRow key={fieldDef?.name}>
            <TableCell component="th" scope="row">
              {fieldDef?.label}:
            </TableCell>
            <TableCell align="left">{formattedValue}</TableCell>
          </TableRow>
        );
      }
    }
  });

  return content;
};
